import type { FaireProductEntity } from "../../entity_types/product";

export const p_2xx7d54z23: FaireProductEntity = {
  token: "p_2xx7d54z23",
  type: "product",
  name: "Arkansas Razorbacks Shiny Gold Logo Charm",
  brandToken: "b_emgllltle6",
  brandName: "Canvas Style",
  imageUrl:
    "https://cdn.faire.com/fastly/91c2dd46d9f17157b38457dfc66330232d8844cf21204501ae26901f62d10cb0.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.85,
  description:
    'Let your Razorback pride shine with the Arkansas Razorbacks Shiny Gold Logo Charm. This sporty charm is ideal for fans who want to add a golden touch to their jewelry collection while showcasing their team loyalty. Mix & Match and add this charm to our Charm Necklace or Bracelets to show off your unique style.\n\nDETAILS: \n18K Triple Gold Plated\n.5"L x .75"W',
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:32.652Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
